/**
 * Tracks which dismissible overlay is on top, so Escape closes only that one.
 *
 * Every overlay (Popup, RightSidebar) listens on `document`, and
 * `stopPropagation` does nothing between listeners attached to the same node —
 * so without this a preview opened inside a form closes both on one press.
 *
 * Every visible overlay registers, closable or not: the topmost layer owns
 * Escape, and one that refuses to close (no `onClose`, or `allowCloseOnEsc`
 * off) absorbs the press rather than handing it to the layer beneath it.
 * Overlays that are mounted but hidden must not register.
 */
const stack: object[] = []

/** Register an overlay as the current topmost. Returns its unregister function. */
export const registerOverlay = (token: object): (() => void) => {
  stack.push(token)
  return () => {
    const index = stack.indexOf(token)
    if (index !== -1) {
      stack.splice(index, 1)
    }
  }
}

export const isTopmostOverlay = (token: object): boolean => stack[stack.length - 1] === token
